import { Component as BaseComponent, h } from 'preact';
import { connect } from 'react-redux';

class Component extends BaseComponent {

    shouldComponentUpdate(nextProps) {
        if (nextProps.decks != this.props.decks) {
            return true;
        }
        return false;
    }

    render() {
        if (this.props.decks && this.props.decks.length > 0 && this.props.deck.type == 'tarot') {
            /* load the decks here only once on interaction */
            return (
                <select onChange={this.props.changeDeck}>
                    <option disabled selected>Choose a Deck</option>
                    {this.props.decks.map((deck) => {
                        return deck.type == 'tarot' ? (<option value={deck.code}>{deck.name}</option>) : null;
                    })}
                </select>
            );
        } else if (this.props.deck.type == 'tarot') {
            return (
                <select onFocus={this.props.loadDecks}>
                    <option disabled selected>Choose a Deck</option>
                </select>
            );
        }
        return null; // mandala
    }

}

const mapDispatchToProps = (dispatch) => ({
    changeDeck: (e) => dispatch({ type: 'deck:required', payload: e.target.value }),
    loadDecks: () => dispatch({ type: 'decks:required'}),
});

const mapStateToProps = (state) => ({
    decks: state.decks,
});

export default connect(mapStateToProps, mapDispatchToProps)(Component);
